export default {
  isSideNavCollapsed(state) {
    return state.isSideNavCollapsed;
  },
  toastOptions(state) {
    return state.toastOptions;
  },
};
